import React from 'react'

import type { SelectOption } from '@fourthwall/components'
import { InputUI, Select } from '@fourthwall/components'
import type { useFormik } from '@fourthwall/utils/dist/formik'
import { TimezonedDatePicker } from '@modules/Timezone/components/TimezonedDatePicker'

import type {
  ActiveMemberAtRule as ActiveMemberAt,
  FormValues,
} from '../../hooks/useBadgeForm/types'
import { FormFields } from '../../hooks/useBadgeForm/types'
import { RuleLayout } from '../RuleLayout'

type Props = {
  form: ReturnType<typeof useFormik<FormValues>>
  options: SelectOption[]
}

export const ActiveMemberAtRule = ({ form, options }: Props) => (
  <div style={{ display: 'grid', gap: 16 }}>
    <RuleLayout
      top={
        <Select
          value={'ActiveMemberAt' satisfies ActiveMemberAt['type']}
          label="Requirement to earn badge"
          options={options}
          onValueChange={(value) => {
            const newRules = form.values.rules.map((rule) =>
              rule.type === 'ActiveMemberAt' ? { type: value } : rule,
            )

            form.setFieldValue(FormFields.rules, newRules)
          }}
        />
      }
      bottom={
        <>
          <TimezonedDatePicker
            labels={['From']}
            dateFormat="MMM D, YYYY, h:mm A"
            showTimeInputs
            value={[
              form.values.activeMemberAtFrom ? new Date(form.values.activeMemberAtFrom) : undefined,
            ]}
            maxDate={
              form.values.activeMemberAtTo ? new Date(form.values.activeMemberAtTo) : undefined
            }
            onChange={(value) => {
              form.setFieldValue(FormFields.activeMemberAtFrom, value[0]?.toISOString())
            }}
            onClear={() => {
              form.setFieldValue(FormFields.activeMemberAtFrom, undefined)
            }}
          />
          <TimezonedDatePicker
            labels={['Until']}
            dateFormat="MMM D, YYYY, h:mm A"
            showTimeInputs
            value={[
              form.values.activeMemberAtTo ? new Date(form.values.activeMemberAtTo) : undefined,
            ]}
            minDate={
              form.values.activeMemberAtFrom ? new Date(form.values.activeMemberAtFrom) : undefined
            }
            onChange={(value) => {
              form.setFieldValue(FormFields.activeMemberAtTo, value[0]?.toISOString())
            }}
            onClear={() => {
              form.setFieldValue(FormFields.activeMemberAtTo, undefined)
            }}
          />
        </>
      }
      onRemove={() => {
        form.setFieldValue(
          FormFields.rules,
          form.values.rules.filter(
            (rule) => rule.type !== ('ActiveMemberAt' satisfies ActiveMemberAt['type']),
          ),
        )
      }}
    />
    {form.errors.activeMemberAtTo && (
      <InputUI.Error $withoutMargin>{form.errors.activeMemberAtTo}</InputUI.Error>
    )}
  </div>
)
